<template>
  <v-container fluid>
    <h4 class="text-h4 mb-4">Summary: Activity</h4>
    <v-chip v-if="pageId" closable class="mb-4" @click:close="router.push({ name: 'summary-activity' })" data-test-id="page-filter">{{ filteredTo }}</v-chip>
    <ActivityList :pageId="pageId" :pageRoute="pageRoute" />
  </v-container>
</template>

<script>
import { computed } from "vue"
import { useRouter } from "vue-router"

import { useActivity } from "@/modules/activity/use"
import { pageName } from "@/modules/activity/describe"
import ActivityList from "@/modules/activity/components/ActivityList"

export default {
  name: "SummaryActivityView",
  components: {
    ActivityList,
  },
  props: {
    pageId: String, // ?pageId=: only the rows touching that page
  },
  setup(props) {
    let router = useRouter()
    let bp_activity = useActivity()

    let filteredTo = computed(() => pageName(props.pageId, bp_activity.ctx.value))

    const pageRoute = (pageId) => {
      return { name: "page-edit-content", params: { pageId }, query: { returnTo: "summary-activity" } }
    }

    return {
      router,
      filteredTo,
      pageRoute,
    }
  },
}
</script>
